export const addBusinessOrganization = 'add-business-organization';
